// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "./http/http"
import Cookies from 'js-cookie'
import "babel-polyfill" //解决Ie白屏问题对es6语法不支持
import JsEncrypt from "jsencrypt"//RSA加密
import compress from './assets/js/compress.js'//图片压缩封装
import request from './assets/js/request.js'//头部底部公用组件请求处理
import submitActive from './assets/js/submitActive.js'//学生激活步骤提交 填写信息
import pleaseCheck from './assets/js/pleaseCheck.js'//学生激活步骤提交 表单验证不通过提示信息
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.styl'
import qs from 'qs'
import {
  Pagination,
  Carousel,
  CarouselItem,
  Loading,
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
  OptionGroup,
  ButtonGroup,
  Col,
  DatePicker,
  TimeSelect,
  TimePicker,
  Switch,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Steps,
  Step,
  Cascader,
  Upload,
  Table,
  Dialog,
  TableColumn,
  Autocomplete
} from 'element-ui'

Vue.config.productionTip = false
Vue.use(Pagination)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Loading)
Vue.use(Form)
Vue.use(Dialog);
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(ButtonGroup)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Cascader)
Vue.use(Upload)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Autocomplete)
Vue.use(TimeSelect)

Vue.prototype.$http = axios
Vue.prototype.$Cookies = Cookies
Vue.prototype.$qs = qs
Vue.prototype.$compress = compress;
Vue.prototype.$req = request
Vue.prototype.$subA = submitActive
Vue.prototype.$pleaseC = pleaseCheck
Vue.prototype.$jsEncrypt = function (parms) {
  let encrypt = new JsEncrypt();
  encrypt.setPublicKey("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCK4n2xrbtnRyBqMJ2iiDeDRdJ/F8EVmzcjSGy/vVNfEVahl6sQOjQXZTc8AEbiZdyLnP9QwX3ZkIsEGUz1VMaPUJeHLHQC5uVljRWR0ORt4oiU7mtN5ZsEl8gPQBzSbC7IpnXVRN1Mx7s/RlFsWZgkuZKbPjxcfgoA9zXyhmcHywIDAQAB");
  let data = encrypt.encrypt(parms);
  return data;
}

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js